import {
  Listbox as HeroUIListbox,
  ListboxItem as HeroUIListboxItem,
  ListboxProps as HeroUIListboxProps,
} from "@heroui/react";

export type ListboxProps = HeroUIListboxProps;

export function Listbox({ children, ...props }: ListboxProps) {
  return <HeroUIListbox {...props}>{children}</HeroUIListbox>;
}

Listbox.displayName = "Recare.Listbox";
Listbox.Item = HeroUIListboxItem;
